<script>
import { Line } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  TimeScale,
} from 'chart.js';
import { ru } from 'date-fns/locale';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  TimeScale,
);

export default {
  name: 'ChartLine',
  components: { LineChart: Line },
  props: {
    data: Array,
    chartColor: String,
    chartId: String,
  },
  computed: {
    dataPoints() {
      return this.data.map(p => ({ x: p?.date, y: p?.value, sort: new Date(p?.date).getTime() })).sort((a, b) => a?.sort - b?.sort);
    },

    suggestedMinX() {
      return [...this.dataPoints].shift()?.x;
    },

    suggestedMaxX() {
      return [...this.dataPoints].pop()?.x;
    },

    stepSizeX() {
      const difference = new Date(this.suggestedMaxX).getMonth() - new Date(this.suggestedMinX).getMonth();

      if (difference > 0 && difference < 3) return 1;
      if (difference > 3 && difference < 4) return 2;

      return 3;
    },

    config() {
      return {
        type: 'line',
        data: this.dataSets,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            customCanvasBackgroundColor: {
              color: 'lightGreen',
            },
          },
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              display: true,
              type: 'time',
              time: {
                unit: 'month',
                stepSize: this.stepSizeX,
                displayFormats: {
                  month: 'LLL',
                },
              },
              adapters: {
                date: {
                  locale: ru,
                },
              },
              suggestedMin: this.suggestedMinX,
              suggestedMax: this.suggestedMaxX,
              beginAtZero: true,
            },
            y: {
              display: true,
              suggestedMin: 0,
              ticks: {
                stepSize: 10,
              },
              beginAtZero: true,
            },
          },
        },
        plugins: {
          backgroundColor: {
            id: 'customCanvasBackgroundColor',
            beforeDraw: (chart, args, options) => {
              const { ctx } = chart;
              ctx.save();
              ctx.globalCompositeOperation = 'destination-over';
              ctx.fillStyle = options.color || '#99ffff';
              ctx.fillRect(0, 100, chart.width, chart.height);
              ctx.restore();
            },
          },
        },
      };
    },

    dataSets() {
      return {
        datasets: [
          {
            label: 'Cubic interpolation',
            data: this.dataPoints,
            borderColor: this.chartColor,
            fill: false,
            tension: 0.5,
            radius: 0,
          },
        ],
      };
    },
  },
};
</script>

<template lang="pug">
  LineChart.chart-canvas(:chart-options="config.options" :chart-data="config.data" :chart-id="'my-chart'")
</template>

<style scoped lang="scss">
.chart-canvas {
  width: 100%;
  height: 100%;
  &::v-deep .canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
